export default __webpack_public_path__ + "static/media/tv-border.6bba619c.svg";